var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 6,
    viewBox: "0 0 16 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 5.16668C3.36328 5.16668 4.33333 4.19663 4.33333 3.00001C4.33333 1.80339 3.36328 0.833344 2.16667 0.833344C0.97005 0.833344 0 1.80339 0 3.00001C0 4.19663 0.97005 5.16668 2.16667 5.16668Z",
    fill: "#727293"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 5.16668C9.1966 5.16668 10.1666 4.19663 10.1666 3.00001C10.1666 1.80339 9.1966 0.833344 7.99998 0.833344C6.80336 0.833344 5.83331 1.80339 5.83331 3.00001C5.83331 4.19663 6.80336 5.16668 7.99998 5.16668Z",
    fill: "#727293"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.00001C16 4.19663 15.03 5.16668 13.8334 5.16668C12.6367 5.16668 11.6667 4.19663 11.6667 3.00001C11.6667 1.80339 12.6367 0.833344 13.8334 0.833344C15.03 0.833344 16 1.80339 16 3.00001Z",
    fill: "#727293"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/DotsIcon.47694b02ca6fd7a7ecd686a4ae3c6c19.svg";
export { ForwardRef as ReactComponent };